import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  TWaterMeter,
  WaterMeterAuthType,
  WaterMeterLocationType,
  WaterMeterModelType,
  WaterMeterType,
} from "types/dto";
import RegionAutoComplete from "components/SpecificAutoComplete/RegionAutoComplete";
import { SortObjectByPropName } from "utils/arrayTools";
import { Enum2Array } from "utils/enumTools";
import SectionMobile from "components/mobileView/SectionMobile";
import TitleValueMobile from "components/mobileView/TitleValueMobile";

type TProps = {
  data?: TWaterMeter;
  isLoading?: boolean;
};

const waterMeterAuthTypeOptions = SortObjectByPropName(
  Enum2Array(WaterMeterAuthType),
  "name"
);
const waterMeterTypeOptions = SortObjectByPropName(
  Enum2Array(WaterMeterType),
  "name"
);
const waterMeterLocationTypeOptions = SortObjectByPropName(
  Enum2Array(WaterMeterLocationType),
  "name"
);
const waterMeterModelTypeOptions = SortObjectByPropName(
  Enum2Array(WaterMeterModelType),
  "name"
);

export const MeterInfoMobile = (props: TProps) => {
  const { data, isLoading } = props;

  const { t } = useTranslation();

  return (
    <SectionMobile
      title={t("meterInfo")}
      collapsible={false}
      isLoading={isLoading}
      skeleton="text"
    >
      <div className="flex flex-col w-full gap-y-3">
        {/*<div className={"grid grid-cols-3 gap-x-2"}>*/}
        <TitleValueMobile title={t("serialNo")} value={data?.serialNo} />
        <TitleValueMobile
          title={t("productionYear")}
          value={data?.productionYear}
        />
        <TitleValueMobile
          title={t("waterMeterType")}
          value={
            waterMeterTypeOptions.find(
              (item) =>
                (item.value as unknown as WaterMeterType) ===
                data?.waterMeterType
            )?.name
          }
        />
        <TitleValueMobile
          title={t("locationType")}
          value={
            waterMeterLocationTypeOptions.find(
              (item) =>
                (item.value as unknown as WaterMeterLocationType) ===
                data?.locationType
            )?.name
          }
        />
        <TitleValueMobile
          title={t("locationType")}
          value={
            waterMeterModelTypeOptions.find(
              (item) =>
                (item.value as unknown as WaterMeterModelType) ===
                data?.modelType
            )?.name
          }
        />
      </div>

      {/*<RegionAutoComplete*/}
      {/*  disabled={true}*/}
      {/*  defaultValue={{*/}
      {/*    provinceId: data?.provinceId,*/}
      {/*    cityId: data?.cityId,*/}
      {/*    jurisdictionId: data?.jurisdictionId,*/}
      {/*  }}*/}
      {/*/>*/}
      {/*</div>*/}
    </SectionMobile>
  );
};
